import {getTransactionIdFromSignPath} from '@utils/helpers';
import {getRecipientIdForSigning} from '@utils/recipientIdResolver';
import {parseJWT} from '@utils/jwtUtils';
import {AUTH_USER_ROLE} from '@constants/user';
import {loadSignerData} from './dataLoader.ts';
import {setUrlRecipientId} from './signerUiSlice';

export default async function ssrFetch({
    store, params
}) {
    const state = store.getState();
    const config = state?.config;
    const accessToken = state?.user?.accessToken;
    const requestPath = state?.app?.requestPath || Object.keys(params)[0];

    const transactionId = params.packageId || params.transaction || getTransactionIdFromSignPath(requestPath);
    const urlRecipientId = params.recipientId || null;
    const recipientId = getRecipientIdForSigning(accessToken, urlRecipientId, transactionId);

    const tokenPayload = parseJWT(accessToken);
    const isUserRole = tokenPayload?.role === AUTH_USER_ROLE;
    const shouldSkipRecipientDependentData = isUserRole;

    store.dispatch(setUrlRecipientId(urlRecipientId));

    if (!transactionId) {
        return;
    }

    await loadSignerData({
        dispatch: store.dispatch,
        getState: store.getState,
        transactionId,
        config,
        accessToken,
        recipientId,
        forceReload: false,
        skipRecipientDependentData: shouldSkipRecipientDependentData
    });
}
